(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const body = document.querySelector('body');
  const removeHatFromCartButtons = document.querySelectorAll('.remove-hat-from-cart-button');
  const toggleSpecificationButtons = document.querySelectorAll('.toggle-specification-button');
  const accessoryItems = document.getElementById('accessory-items');
  const originalTotalCartPriceElement = document.getElementById('original-total-cart-price');
  const finalTotalCartPriceElement = document.getElementById('final-total-cart-price');
  const schoolClassInput = document.getElementById('school-class-input');
  const schoolSelector = document.getElementById('school-selector-container');
  const checkoutButton = document.getElementById('checkout-button');
  const saveHatButtons = Array.from(document.getElementsByClassName('save-hat-button'));
  const saveHatPopUp = document.getElementById('save-hat-popup');
  const checkoutErrorText = document.getElementById('checkout-error-text');

  let schoolName = cart.attributes._schoolName || null;
  let schoolClass = cart.attributes._schoolClass || null;

  let checkoutError = false;

  // Uses Shopify's cart API to remove a set of line items from the cart.
  const removeItemsFromCart = (items) => {
    const updates = items.reduce((acc, item) => {
      acc[item.key] = 0;
      return acc;
    }, {});

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update a cart item's quantity.
  const updateCartItemQuantity = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, quantity }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update the school name attribute in the cart.
  const updateCartSchoolName = (schoolName, garpCustomer, schoolDelivery) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          _schoolName: schoolName,
          _garpCustomer: garpCustomer,
          _schoolDelivery: schoolDelivery,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update the school class attribute in the cart.
  const updateCartSchoolClass = (schoolClass) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          _schoolClass: schoolClass,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Remove all items from the cart that match the given hatId.
  const removeHatFromCart = async (hatId) => {
    const hatItems = cart.items.filter(({ properties }) => properties._hatId === hatId);

    // Remove old items from the cart.
    if (hatItems.length > 0) {
      await removeItemsFromCart(hatItems);
    }
  };

  // When a remove hat from cart button is clicked, remove the corresponding hat from the cart.
  removeHatFromCartButtons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      const hatId = event.target.dataset.hatId;
      await removeHatFromCart(hatId);
      window.location.reload();
    });
  });

  // When a toggle specification button is clicked, toggle the visibility of the hat's specification.
  toggleSpecificationButtons.forEach((button) => {
    button.addEventListener('click', () => button.classList.toggle('active'));
  });

  // Add event listeners to accessory item quantity update and remove buttons.
  if (accessoryItems) {
    accessoryItems.querySelectorAll('li').forEach((item) => {
      const itemId = item.dataset.itemId;
      const decrementButton = item.querySelector('.decrement-quantity');
      const incrementButton = item.querySelector('.increment-quantity');
      const quantityElement = item.querySelector('.decrement-quantity').nextElementSibling;
      const removeButton = item.querySelector('.remove-accessory-item-from-cart');

      var quantityChangeTimeout;

      const removeFromCart = async () => {
        await updateCartItemQuantity(itemId, 0);
      };

      const updateQuantity = (quantityChange) => {
        const inventoryQuantity = parseInt(item.dataset.inventoryQuantity);
        const quantity = parseInt(item.dataset.quantity);
        const newQuantity = Math.min(quantity + quantityChange, inventoryQuantity);

        if (newQuantity > 0) {
          clearTimeout(quantityChangeTimeout);

          quantityElement.textContent = `${newQuantity} st`;
          item.dataset.quantity = newQuantity;

          if (newQuantity === 1) {
            decrementButton.setAttribute('disabled', '');
          } else {
            decrementButton.removeAttribute('disabled');
          }

          if (newQuantity === inventoryQuantity) {
            incrementButton.setAttribute('disabled', '');
          } else {
            incrementButton.removeAttribute('disabled');
          }

          quantityChangeTimeout = setTimeout(() => {
            updateCartItemQuantity(itemId, newQuantity);
          }, 300);
        }
      };

      decrementButton.addEventListener('click', () => updateQuantity(-1));
      incrementButton.addEventListener('click', () => updateQuantity(1));
      removeButton.addEventListener('click', () => removeFromCart());
    });
  }

  // Listens for cart changes and updates the cart accordingly.
  window.addEventListener('cart_changed', ({ detail }) => {
    const updatedCartItems = [...detail.added, ...detail.removed];

    if (updatedCartItems.length === 0) return;

    updatedCartItems.forEach(({ id }) => {
      const lineItemElement = accessoryItems.querySelector(`li[data-item-id='${id}']`);
      const totalLinePriceElement = lineItemElement.querySelector('.total-line-price');

      const lineItem = detail.cart.items.find((item) => item.id === id);
      const quantity = lineItem?.quantity ?? 0;
      const totalLinePrice = lineItem?.final_line_price ?? 0;

      if (quantity > 0) {
        totalLinePriceElement.textContent = Shopify.formatMoney(totalLinePrice);
      } else {
        lineItemElement.remove();
      }
    });

    if (detail.cart.item_count === 0) {
      window.location.reload();
    }

    originalTotalCartPriceElement.textContent = Shopify.formatMoney(detail.cart.total_price + totalDiscount);
    finalTotalCartPriceElement.textContent = Shopify.formatMoney(detail.cart.total_price);
  });

  // Add school to cart attributes when a school is selected.
  // Unlock the checkout button if there are items in the cart and both school and class are set.
  schoolSelector.addEventListener('schoolSelected', (event) => {
    const notFound = event.detail?.notFound || false;
    schoolName = !notFound ? event.detail?.name || null : 'Jag hittar inte min skola';
    const garpCustomer = event.detail?.garpCustomer || null;
    const schoolDelivery = event.detail?.schoolDelivery || null;

    updateCartSchoolName(schoolName, garpCustomer, schoolDelivery);

    if (cart.item_count > 0 && schoolName && schoolClass) {
      checkoutButton.classList.add('bg-onSurface', 'text-white');
      checkoutButton.classList.remove('bg-inactiveLightGrey', 'text-inactiveGrey');
    } else {
      checkoutButton.classList.add('bg-inactiveLightGrey', 'text-inactiveGrey');
      checkoutButton.classList.remove('bg-onSurface', 'text-white');
    }

    checkoutErrorText.classList.add('hidden');
  });

  // Add school class to cart attributes when the input field changes.
  // Unlock the checkout button if there are items in the cart and both school and class are set.
  schoolClassInput.addEventListener('change', (event) => {
    schoolClass = event.target.value || null;

    updateCartSchoolClass(schoolClass);

    if (cart.item_count > 0 && schoolName && schoolClass) {
      checkoutButton.classList.add('bg-onSurface', 'text-white');
      checkoutButton.classList.remove('bg-inactiveLightGrey', 'text-inactiveGrey');
    } else {
      checkoutButton.classList.add('bg-inactiveLightGrey', 'text-inactiveGrey');
      checkoutButton.classList.remove('bg-onSurface', 'text-white');
    }

    checkoutErrorText.classList.add('hidden');
  });

  // Prevent checkout if the cart is empty or school/class is not selected. Show error message if necessary.
  checkoutButton.addEventListener('click', (event) => {
    if (cart.item_count === 0 || !schoolName || !schoolClass) {
      event.preventDefault();
      if (cart.item_count > 0) {
        checkoutErrorText.classList.remove('hidden');
      }
    }
  });

  // Open the save hat popup when the save hat button is clicked.
  saveHatButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (window.scrollY < 36) {
        window.scrollTo({ top: 36 });
      }
      saveHatPopUp.classList.add('flex');
      saveHatPopUp.classList.remove('hidden');
      body.classList.add('overflow-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  var productLoop = document.getElementById('product-loop');
  var productPagination = document.getElementById('product-pagination');

  // Using the given query params, fetch the HTML of the corresponding products grid.
  // Forces the 'filter.p.m.gung.exclude_from_list' filter to be '0', if the 'filter.p.m.gung.dimension_1_filterColor_name' filter is unset.
  const fetchProducts = (params) => {
    const url = new URL(window.location.href);
    params.set('view', 'products');

    if (!params.has('filter.p.m.gung.dimension_1_filterColor_name')) {
      params.set('filter.p.m.gung.exclude_from_list', '0');
    }

    return fetch(`${url.pathname}?${params.toString()}`)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return {
          loop: doc.getElementById('product-loop'),
          pagination: doc.getElementById('product-pagination'),
        };
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Initial setup on page load.
  document.addEventListener('DOMContentLoaded', async () => {
    const params = new URLSearchParams(window.location.search);
    const { loop, pagination } = await fetchProducts(params);

    productLoop.outerHTML = loop.outerHTML;
    productPagination.outerHTML = pagination.outerHTML;

    productLoop = document.getElementById('product-loop');
    productPagination = document.getElementById('product-pagination');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["continue-design-popup"]) return;
  try {
    
  const body = document.querySelector('body');
  const continueDesignPopup = document.getElementById('continue-design-popup');
  const continueDesignButton = document.getElementById('continue-design-button');
  const restartDesignButton = document.getElementById('restart-design-button');

  // If the continue design popup is shown, lock the body scroll.
  if (continueDesignPopup) {
    body.classList.add('overflow-hidden');
  }

  // Uses Shopify's cart API to remove a set of line items from the cart.
  const removeItemsFromCart = (items) => {
    const updates = items.reduce((acc, item) => {
      acc[item.key] = 0;
      return acc;
    }, {});

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to remove all discounts from the cart.
  const clearCartDiscounts = (discountCode) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: '',
        attributes: {
          _schoolDiscountId: null,
          _schoolDiscountIds: null,
          _discounts: null,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Remove all items from the cart which belongs to a hat.
  const removeHatsFromCart = async () => {
    const hatItems = cart.items.filter(({ properties }) => properties._hatId);

    // Remove old items from the cart.
    if (hatItems.length > 0) {
      await removeItemsFromCart(hatItems);
    }
  };

  if (continueDesignPopup && restartDesignButton) {
    // If the restart design button is clicked, clear the cart and reload the page.
    restartDesignButton.addEventListener('click', async () => {
      continueDesignButton.classList.add('pointer-events-none');
      restartDesignButton.classList.add('pointer-events-none');
      restartDesignButton.querySelector('span').classList.add('hidden');
      restartDesignButton.querySelector('.fa-spinner-third').parentElement.classList.remove('hidden');

      await removeHatsFromCart();
      await clearCartDiscounts();

      window.location.reload();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  const faqButtons = document.querySelectorAll('#questions-and-answers button');

  faqButtons.forEach((button) => {
    const answer = button.nextElementSibling;
    const plusIcon = button.querySelector('.fa-plus').parentElement;
    const minusIcon = button.querySelector('.fa-minus').parentElement;

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('data-expanded') === 'true';
      button.setAttribute('data-expanded', !expanded);

      if (expanded) {
        answer.classList.add('hidden');
        plusIcon.classList.remove('hidden');
        minusIcon.classList.add('hidden');
      } else {
        answer.classList.remove('hidden');
        plusIcon.classList.add('hidden');
        minusIcon.classList.remove('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fetch-saved-hat"]) return;
  try {
    
  const fetchSavedHatTitle = document.getElementById('fetch-saved-hat-title');
  const fetchSavedHatBodyText = document.getElementById('fetch-saved-hat-body-text');
  const fetchSavedHatButton = document.getElementById('fetch-saved-hat');
  const declineFetchSavedHatButton = document.getElementById('decline-fetch-saved-hat');
  const designNewHatButton = document.getElementById('design-new-hat');

  // Sends a request to save the hat to the server.
  const fetchHat = async (savedHatId) => {
    return fetch('https://api.vardagsbaret.shop/saved-cart/' + savedHatId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .catch((e) => {
        throw e;
      });
  };

  // Uses Shopify's cart API to remove a set of line items from the cart.
  const removeItemsFromCart = (items) => {
    const updates = items.reduce((acc, item) => {
      acc[item.key] = 0;
      return acc;
    }, {});

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update the cart attributes.
  const updateCartAttribtes = (attributes) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: attributes._discounts || '',
        attributes,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update the cart items.
  const updateCartItems = async (items) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Remove all items from the cart which belongs to a hat.
  const removeHatsFromCart = async () => {
    const hatItems = cart.items.filter(({ properties }) => properties._hatId);

    // Remove old items from the cart.
    if (hatItems.length > 0) {
      await removeItemsFromCart(hatItems);
    }
  };

  // Fetch all schools from the paginated school JSON page.
  const fetchAllSchools = async () => {
    const schools = [];

    let url = schoolJsonPage;

    const fetchSchools = async (url) => {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const schools = Array.from(doc.getElementById('school-loop')?.children || []);
      const nextUrl = doc.getElementById('school-pagination-next')?.getAttribute('href');

      return { schools, nextUrl };
    };

    while (url) {
      const result = await fetchSchools(url);
      schools.push(...result.schools);
      url = result.nextUrl;
    }

    return schools;
  };

  // Handles the click event for fetching the saved hat.
  fetchSavedHatButton.addEventListener('click', async () => {
    declineFetchSavedHatButton.classList.add('pointer-events-none');
    fetchSavedHatButton.classList.add('pointer-events-none');
    fetchSavedHatButton.querySelector('span').classList.add('hidden');
    fetchSavedHatButton.querySelector('.fa-spinner-third').parentElement.classList.remove('hidden');

    try {
      const data = await fetchHat(savedHatId);
      const savedCart = data.cart;
      const attributes = savedCart.attributes;
      const items = savedCart.items;

      const schools = await fetchAllSchools();
      const school = schools.find((s) => s.dataset.name === attributes._schoolName);

      await removeHatsFromCart();

      await updateCartAttribtes({
        _schoolDiscountId: attributes._schoolDiscountId || null,
        _schoolDiscountIds: attributes._schoolDiscountIds || null,
        _discounts: attributes._discounts || null,
        _schoolName: attributes._schoolName || null,
        _schoolClass: attributes._schoolClass || null,
        // Re-read to update potentially old values.
        _garpCustomer: school ? school.dataset.garpCustomer || null : attributes._garpCustomer || null,
        _schoolDelivery: school ? school.dataset.schoolDelivery : attributes._schoolDelivery || null,
      });

      await updateCartItems(items);

      window.location.href = cartUrl;
    } catch (error) {
      fetchSavedHatButton.remove();
      declineFetchSavedHatButton.remove();

      switch (error.message) {
        case '410':
          if (goneTitle) fetchSavedHatTitle.textContent = goneTitle;
          if (goneBodyText) fetchSavedHatBodyText.textContent = goneBodyText;
          designNewHatButton.classList.add('flex');
          designNewHatButton.classList.remove('hidden');
          break;
        default:
          if (fetchSavedHatTitle) fetchSavedHatTitle.textContent = errorTitle;
          if (fetchSavedHatBodyText) fetchSavedHatBodyText.textContent = errorMessage;
          break;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hat-designer"]) return;
  try {
    
  const addToCartForm = document.getElementById('add-to-cart-form');
  const submitButton = document.getElementById('submit-button');
  const sizeSelector = document.getElementById('size-selector');
  const modelViewer = document.querySelector('model-viewer');

  // Uses Shopify's cart API to add a set of products to the cart.
  const addProductsToCart = (items) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to remove a set of line items from the cart.
  const removeItemsFromCart = (items) => {
    const updates = items.reduce((acc, item) => {
      acc[item.key] = 0;
      return acc;
    }, {});

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Remove all items from the cart which belongs to a hat.
  const removeHatsFromCart = async () => {
    const hatItems = cart.items.filter(({ properties }) => properties._hatId);

    // Remove old items from the cart.
    if (hatItems.length > 0) {
      await removeItemsFromCart(hatItems);
    }
  };

  // When an option is selected...
  addToCartForm.addEventListener('change', (event) => {
    const option = event.target.name;
    const value = event.target.value;
    const optionMaterialNames = event.target.dataset.materialNames?.split('\n') ?? [];

    const formData = new FormData(addToCartForm);

    const updateVariantName = (variant, index) => {
      variantName = variantName
        .split('-')
        .map((part, i) => {
          return i === index ? variant : part;
        })
        .join('-');
    };

    const updateMaterialNames = () => {
      materialNames = [
        ...crownMaterialNames,
        ...upperPipingMaterialNames,
        ...lowerPipingMaterialNames,
        ...cockadeMaterialNames,
        ...stoneMaterialNames,
        ...brimMaterialNames,
        ...sweatBandMaterialNames,
        ...bowMaterialNames,
        ...liningMaterialNames,
        ...embroideryNameMaterialNames,
        ...embroideryBandMaterialNames,
        ...embroideryCrownMaterialNames,
        ...topEmblemMaterialNames,
      ];
    };

    switch (option) {
      case 'crown-product':
        crownMaterialNames = optionMaterialNames;
        updateVariantName(value, 0);
        break;
      case 'upper-piping':
        upperPipingMaterialNames = optionMaterialNames;
        updateVariantName(value, 1);
        break;
      case 'lower-piping':
        lowerPipingMaterialNames = optionMaterialNames;
        updateVariantName(value, 2);
        break;
      case 'cockade':
        cockadeMaterialNames = optionMaterialNames;
        updateVariantName(value, 3);
        break;
      case 'stone':
        stoneMaterialNames = optionMaterialNames;
        updateVariantName(value, 4);
        break;
      case 'brim':
        brimMaterialNames = optionMaterialNames;
        updateVariantName(value, 5);
        break;
      case 'sweatband':
        sweatBandMaterialNames = optionMaterialNames;
        updateVariantName(value, 6);
        break;
      case 'bow':
        bowMaterialNames = optionMaterialNames;
        updateVariantName(value, 7);
        break;
      case 'lining':
        liningMaterialNames = optionMaterialNames;
        updateVariantName(value, 8);
        break;
      case 'embroidery-name':
        embroideryNameMaterialNames = optionMaterialNames;
        updateVariantName(value, 9);
      case 'embroidery-name-text1':
        updateEmbroidery(
          formData.get('embroidery-name-text1'),
          formData.get('embroidery-name-style'),
          embroideryNameMaterialNames.filter((name) => name.includes('firstname'))
        );
      case 'embroidery-name-text2':
        updateEmbroidery(
          formData.get('embroidery-name-text2'),
          formData.get('embroidery-name-style'),
          embroideryNameMaterialNames.filter((name) => name.includes('lastname'))
        );
        break;
      case 'embroidery-band':
        embroideryBandMaterialNames = optionMaterialNames;
        updateVariantName(value, 10);
      case 'embroidery-band-text':
        updateEmbroidery(
          formData.get('embroidery-band-text'),
          formData.get('embroidery-band-style'),
          embroideryBandMaterialNames
        );
        break;
      case 'embroidery-crown':
        embroideryCrownMaterialNames = optionMaterialNames;
        updateVariantName(value, 11);
      case 'embroidery-crown-text':
        updateEmbroidery(
          formData.get('embroidery-crown-text'),
          formData.get('embroidery-crown-style'),
          embroideryCrownMaterialNames
        );
        break;
      case 'top-emblem':
        topEmblemMaterialNames = optionMaterialNames;
        updateVariantName(value, 12);
        break;
      default:
        return;
    }

    updateMaterialNames();
    updateModelTextures(variantName, materialNames);
  });

  // When the add to cart form is submitted...
  addToCartForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    const defaultBehavior = event.submitter?.id === 'submit-button';

    if (defaultBehavior) {
      submitButton.classList.add('pointer-events-none');
      submitButton.querySelector('span').classList.add('hidden');
      submitButton.querySelector('.fa-spinner-third').parentElement.classList.remove('hidden');
    }

    const formData = new FormData(addToCartForm);

    const crownProductId = formData.get('crown-product');
    const crownVariantId = formData.get('crown-variant');
    const cockadeVariantId = formData.get('cockade');
    const brimVariantId = formData.get('brim');
    const sweatBandVariantId = formData.get('sweatband');
    const bowVariantId = formData.get('bow');
    const liningVariantId = formData.get('lining');

    const upperPipingEmptyOption =
      addToCartForm.querySelector('input[name="upper-piping"]:checked')?.dataset?.emptyOption || 'false';

    const lowerPipingEmptyOption =
      addToCartForm.querySelector('input[name="lower-piping"]:checked')?.dataset?.emptyOption || 'false';

    const stoneEmptyOption =
      addToCartForm.querySelector('input[name="stone"]:checked')?.dataset?.emptyOption || 'false';

    const embroideryNameEmptyOption =
      addToCartForm.querySelector('input[name="embroidery-name"]:checked')?.dataset?.emptyOption || 'false';
    const embroideryNameText1 = formData.get('embroidery-name-text1');
    const embroideryNameText2 = formData.get('embroidery-name-text2');

    const embroideryBandEmptyOption =
      addToCartForm.querySelector('input[name="embroidery-band"]:checked')?.dataset?.emptyOption || 'false';
    const embroideryBandText = formData.get('embroidery-band-text');

    const embroideryCrownEmptyOption =
      addToCartForm.querySelector('input[name="embroidery-crown"]:checked')?.dataset?.emptyOption || 'false';
    const embroideryCrownText = formData.get('embroidery-crown-text');

    const topEmblemEmptyOption =
      addToCartForm.querySelector('input[name="top-emblem"]:checked')?.dataset?.emptyOption || 'false';

    if (
      !crownProductId ||
      !crownVariantId ||
      !cockadeVariantId ||
      !brimVariantId ||
      !sweatBandVariantId ||
      !bowVariantId ||
      !liningVariantId
    ) {
      if (defaultBehavior) {
        submitButton.classList.remove('pointer-events-none');
        submitButton.querySelector('span').classList.remove('hidden');
        submitButton.querySelector('.fa-spinner-third').parentElement.classList.add('hidden');
      }
      return;
    }

    hatId = hatId || Date.now().toString();

    // Set camera position for the screenshot.
    // We need to wait a short moment to ensure the camera settings are applied before taking the screenshot.
    // *10ms* is arbitrary.
    await new Promise((resolve) => {
      modelViewer.cameraControls = false;
      modelViewer.interpolationDecay = 0;
      modelViewer.cameraTarget = '0m 30m 0m';
      modelViewer.cameraOrbit = '65deg 80deg 550m';

      setTimeout(resolve, 10);
    });

    // Remove old hat items from the cart.
    await removeHatsFromCart();

    let newHatItems = [];

    for (const [key, value] of formData.entries()) {
      const properties = { _hatId: hatId };

      switch (key) {
        case 'crown-product':
        case 'embroidery-name-style':
        case 'embroidery-name-color':
        case 'embroidery-name-text1':
        case 'embroidery-name-text2':
        case 'embroidery-band-style':
        case 'embroidery-band-color':
        case 'embroidery-band-text':
        case 'embroidery-crown-style':
        case 'embroidery-crown-color':
        case 'embroidery-crown-text':
          continue; // Skip these as they are not products which should be added to the cart.
        case 'crown-variant':
          properties._screenshot = screenshotHat(); // Screenshot the hat.
          break;
        case 'upper-piping':
          if (upperPipingEmptyOption === 'true') continue;
          break;
        case 'lower-piping':
          if (lowerPipingEmptyOption === 'true') continue;
          break;
        case 'stone':
          if (stoneEmptyOption === 'true') continue;
          break;
        case 'embroidery-name':
          if (
            embroideryNameEmptyOption === 'true' ||
            (!schoolDiscount && !embroideryNameText1 && !embroideryNameText2)
          ) {
            continue;
          }
          properties.text1 = embroideryNameText1 ?? '';
          properties.text2 = embroideryNameText2 ?? '';
          break;
        case 'embroidery-band':
          if (embroideryBandEmptyOption === 'true' || (!schoolDiscount && !embroideryBandText)) {
            continue;
          }
          properties.text = embroideryBandText ?? '';
          break;
        case 'embroidery-crown':
          if (embroideryCrownEmptyOption === 'true' || (!schoolDiscount && !embroideryCrownText)) {
            continue;
          }
          properties.text = embroideryCrownText ?? '';
          break;
        case 'top-emblem':
          if (topEmblemEmptyOption === 'true') continue;
          break;
      }

      const id = parseInt(value);

      if (id) {
        newHatItems.push({
          id,
          quantity: 1,
          properties,
        });
      }
    }

    await addProductsToCart(newHatItems);

    // If the form was submitted using the submit button:
    // Redirect to the upsell page.
    // If no upsell URL is set, redirect to the cart page.
    if (defaultBehavior) {
      window.location.href = upsellUrl || cartUrl;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const body = document.querySelector('body');
  const cartItemCountElement = document.getElementById('cart-item-count');
  const sideMenu = document.getElementById('side-menu');
  const sideMenuButton = document.getElementById('side-menu-button');

  var activeSideMenu = false;

  // Function to toggle side menu visibility
  const toggleSideMenu = () => {
    activeSideMenu = !activeSideMenu;

    if (activeSideMenu) {
      body.classList.add('overflow-y-hidden');
      sideMenu.classList.add('translate-x-full');
      sideMenuButton.querySelector('span').innerHTML = 'Stäng';
      sideMenuButton.querySelector('.fa-bars').parentElement.classList.add('hidden');
      sideMenuButton.querySelector('.fa-xmark').parentElement.classList.remove('hidden');
    } else {
      body.classList.remove('overflow-y-hidden');
      sideMenu.classList.remove('translate-x-full');
      sideMenuButton.querySelector('span').innerHTML = 'Meny';
      sideMenuButton.querySelector('.fa-bars').parentElement.classList.remove('hidden');
      sideMenuButton.querySelector('.fa-xmark').parentElement.classList.add('hidden');
    }
  };

  // Update cart item count when the cart is changed.
  window.addEventListener('cart_changed', ({ detail }) => {
    const hatIds = [];

    let cartItemCount = 0;

    detail.cart.items.forEach((item) => {
      const hatId = item.properties._hatId;
      if (hatId) {
        if (!hatIds.includes(hatId)) {
          hatIds.push(hatId);
        }
      } else {
        cartItemCount += item.quantity;
      }
    });

    cartItemCount += hatIds.length;

    cartItemCountElement.textContent = cartItemCount || '';
  });

  // When the side menu button is clicked, toggle the side menu
  sideMenuButton.addEventListener('click', toggleSideMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  const body = document.querySelector('body');
  const newsletterPopup = document.getElementById('newsletter-popup');
  const closeNewsletterPopupButton = document.getElementById('close-newsletter-popup-button');

  // Open the newsletter popup.
  const openNewsletterPopup = () => {
    body.classList.add('overflow-hidden');
    newsletterPopup.classList.remove('hidden');
    newsletterPopup.classList.add('flex');
  };

  // Close the newsletter popup.
  const closeNewsletterPopup = () => {
    localStorage.setItem('newsletter-popup-closed', Date.now().toString());

    const body = document.querySelector('body');

    body.classList.remove('overflow-hidden');
    newsletterPopup.classList.remove('flex');
    newsletterPopup.classList.add('hidden');
  };

  // Check if the newsletter popup should be opened based on the timestamp stored in sessionStorage.
  // The popup will open if it has never been closed before or if it was closed more than 5 days ago.
  document.addEventListener('DOMContentLoaded', () => {
    const newsletterTimestamp = parseInt(localStorage.getItem('newsletter-popup-closed'));
    if (
      themeEditor === false &&
      (newsletterTimestamp === undefined ||
        isNaN(newsletterTimestamp) ||
        Date.now() - newsletterTimestamp > 5 * 24 * 60 * 60 * 1000)
    ) {
      openNewsletterPopup();
    }
  });

  // When the close button is clicked, close the popup.
  closeNewsletterPopupButton.addEventListener('click', closeNewsletterPopup);

  // When the background is clicked, close the popup.
  newsletterPopup.addEventListener('click', (event) => {
    if (event.target === newsletterPopup) {
      closeNewsletterPopup();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const productImageCarousel = document.getElementById('product-image-carousel');
  const previousImageButton = document.getElementById('previous-image-button');
  const nextImageButton = document.getElementById('next-image-button');
  const productSiblings = document.getElementById('product-sibligns');
  const variantForm = document.getElementById('variant-form');
  const addToCartButton = document.getElementById('add-to-cart-button');
  const extraInfoWrapper = document.getElementById('extra-info-wrapper');

  const variantCount = variantForm.querySelectorAll('input').length;

  var variantId = variantForm.querySelector('input:checked')?.value;
  var variantTitle = variantForm.querySelector('input:checked')?.parentElement.textContent.trim();

  // Uses Shopify's cart API to add the product to the cart.
  const addProductToCart = () => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Scrolls the image carousel in the given direction (-1 for left, 1 for right).
  const scrollImageCarousel = (direction) => {
    const imageCount = productImageCarousel.childElementCount;
    const scrollAmount = productImageCarousel.clientWidth / imageCount;

    productImageCarousel.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth',
    });
  };

  // Updates the visibility of the previous/next image buttons based on the scroll position of the image carousel.
  const scrollButtonVisibility = () => {
    const scrollLeft = productImageCarousel.scrollLeft;
    const scrollWidth = productImageCarousel.scrollWidth;
    const clientWidth = productImageCarousel.clientWidth;

    if (scrollLeft === 0) {
      previousImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      previousImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }

    if (scrollLeft + clientWidth >= scrollWidth) {
      nextImageButton.classList.add('opacity-0', 'pointer-events-none');
    } else {
      nextImageButton.classList.remove('opacity-0', 'pointer-events-none');
    }
  };

  if (productImageCarousel) {
    productImageCarousel.addEventListener('scroll', scrollButtonVisibility);
  }

  // When clicking the previous/next image buttons, scroll the image carousel.
  if (previousImageButton && nextImageButton) {
    previousImageButton.addEventListener('click', () => scrollImageCarousel(-1));
    nextImageButton.addEventListener('click', () => scrollImageCarousel(1));
  }

  // When clicking a sibling product, navigate to that product's URL.
  if (productSiblings) {
    productSiblings.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const productUrl = button.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl + (variantCount > 1 && variantTitle ? `/vt=${variantTitle}` : '');
        }
      });
    });
  }

  // When changing the selected variant, update the "variantId" and "variantTitle" variables.
  variantForm.addEventListener('change', (event) => {
    if (event.target.name === 'variant' && localeIsoCode === 'sv') {
      variantId = event.target.value;
      variantTitle = event.target.parentElement.textContent.trim();
      addToCartButton.disabled = false;
    }
  });

  // When clicking the "Add to cart" button, add the selected variant to the cart.
  addToCartButton.addEventListener('click', async () => {
    if (variantId) {
      addToCartButton.classList.add('pointer-events-none');
      addToCartButton.querySelector('span').classList.add('hidden');
      addToCartButton.querySelector('.fa-spinner-third').parentElement.classList.remove('hidden');

      await addProductToCart();

      addToCartButton.classList.remove('pointer-events-none');
      addToCartButton.querySelector('span').classList.remove('hidden');
      addToCartButton.querySelector('.fa-spinner-third').parentElement.classList.add('hidden');
    }
  });

  // When clicking an extra info button, toggle the visibility of the corresponding content.
  extraInfoWrapper.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => {
      const buttonStateIndicator = button.querySelector('span:last-child');
      const content = button.nextElementSibling;

      if (content) {
        if (content.classList.contains('hidden')) {
          content.classList.remove('hidden');
          content.classList.add('flex');
          buttonStateIndicator.textContent = '-';
        } else {
          content.classList.add('hidden');
          content.classList.remove('flex');
          buttonStateIndicator.textContent = '+';
        }
      }
    });
  });

  // When the cart is changed, disable variant options that cannot be added to the cart due to insufficient inventory.
  // If all variants are disabled, show the "Out of stock" message.
  window.addEventListener('cart_changed', ({ detail }) => {
    var available = false;

    if (localeIsoCode === 'sv') {
      variantForm.querySelectorAll('input').forEach((input) => {
        const inventoryQuantity = parseInt(input.dataset.inventoryQuantity);
        const cartItemCount = detail.cart.items.find((item) => item.id == input.value)?.quantity || 0;

        if (inventoryQuantity - cartItemCount <= 0) {
          input.disabled = true;
          if (input.checked) {
            input.checked = false;
            addToCartButton.disabled = true;
          }
        } else {
          available = true;
          input.disabled = false;
          if (input.checked) {
            addToCartButton.disabled = false;
          }
        }
      });
    }

    if (!available) {
      addToCartButton.nextElementSibling.classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["save-hat-popup"]) return;
  try {
    
  const body = document.querySelector('body');
  const saveHatPopup = document.getElementById('save-hat-popup');
  const saveHatForm = document.getElementById('save-hat-form');
  const closeSaveHatPopupButton = document.getElementById('close-save-hat-popup-button');
  const title = document.querySelector('#save-hat-popup h2');
  const bodyText = document.querySelector('#save-hat-popup .text-caption');
  const spinnerContainer = saveHatForm.querySelector('.fa-spinner-third').parentElement;
  const emailInput = saveHatForm.querySelector('input[name="email"]');
  const submitButton = saveHatForm.querySelector('button[type="submit"]');
  const addToCartForm = document.getElementById('add-to-cart-form');

  let cartToSave = cart;

  // Sends a request to save the hat to the server.
  const saveHat = async (cart, email) => {
    return fetch('https://api.vardagsbaret.shop/saved-cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cart, email }),
    })
      .then((response) => {
        return response.status === 201;
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const closeSaveHatPopup = () => {
    saveHatPopup.classList.add('hidden');
    saveHatPopup.classList.remove('flex');

    body.classList.remove('overflow-hidden');

    saveHatForm.classList.remove('hidden');
    spinnerContainer.classList.add('hidden');
    spinnerContainer.classList.remove('flex');
    emailInput.classList.remove('hidden');
    submitButton.classList.remove('hidden');

    saveHatForm.reset();

    if (title) title.textContent = saveHatTitle;
    if (bodyText) bodyText.textContent = saveHatBodyText;
  };

  // Close the popup when the background is clicked or the close button is clicked.
  closeSaveHatPopupButton?.addEventListener('click', closeSaveHatPopup);

  // Close the popup if the background (not the inner content) is clicked.
  // Note that stopping event propagation when clicking inside the popup
  // breaks other click handlers, so this method has to be used instead.
  saveHatPopup.addEventListener('click', (event) => {
    if (event.target === saveHatPopup) {
      closeSaveHatPopup();
    }
  });

  // Listen for changes to the cart and automatically submit the save hat form if items are added.
  window.addEventListener('cart_changed', ({ detail }) => {
    if (detail.added.length) {
      cartToSave = detail.cart;
      saveHatForm.requestSubmit();
    }
  });

  // Handle the form submission and show the success message.
  saveHatForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    const formData = new FormData(saveHatForm);
    const email = formData.get('email');

    if (!email) return;

    const parsedCart = {
      attributes: {
        _schoolDiscountId: cartToSave.attributes._schoolDiscountId || null,
        _schoolDiscountIds: cartToSave.attributes._schoolDiscountIds || null,
        _discounts: cartToSave.attributes._discounts || null,
        _schoolName: cartToSave.attributes._schoolName || null,
        _schoolClass: cartToSave.attributes._schoolClass || null,
      },
      items: cartToSave.items
        .filter(({ properties }) => properties._hatId)
        .map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties,
        })),
    };

    emailInput.classList.add('hidden');
    submitButton.classList.add('hidden');
    spinnerContainer.classList.add('flex');
    spinnerContainer.classList.remove('hidden');

    // Submit the add to cart form if it exists and the save hat button was clicked.
    // Meaning: if we are on the hat-designer page, and the user clicked the save hat button.
    if (addToCartForm && event.submitter?.id === 'submit-save-hat-button') {
      addToCartForm.requestSubmit();
      return;
    }

    const success = await saveHat(parsedCart, email);

    if (success) {
      if (title) title.textContent = saveHatSuccessTitle;
      if (bodyText) bodyText.textContent = saveHatSuccessBodyText;

      saveHatForm.classList.add('hidden');
    } else {
      if (title) title.textContent = saveHatErrorTitle;
      if (bodyText) bodyText.textContent = saveHatErrorBodyText;

      spinnerContainer.classList.add('hidden');
      spinnerContainer.classList.remove('flex');
      emailInput.classList.remove('hidden');
      submitButton.classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-discount-popup"]) return;
  try {
    
  const body = document.querySelector('body');
  const schoolDiscountPopup = document.getElementById('school-discount-popup');
  const closeSchoolDiscountPopupButton = document.getElementById('close-school-discount-popup-button');
  const schoolForm = document.getElementById('school-form');
  const schoolSelectorWrapper = document.getElementById('school-selector-wrapper');
  const schoolSelector = document.getElementById('school-selector-container');
  const schoolDiscountsContainer = document.getElementById('school-discounts-container');
  const schoolDiscountSuccessTitle = document.getElementById('school-discount-success-title');
  const schoolDiscountSuccessBodyText = document.getElementById('school-discount-success-body-text');
  const defaultButton = schoolDiscountsContainer?.querySelector('button[data-school-discount-id=""]');

  // If the school discount popup is shown, scroll to the top of the screen and lock the body scroll.
  if (schoolDiscountPopup) {
    history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    body.classList.add('overflow-hidden');
  }

  // Uses Shopify's cart API to update the discounts in the cart.
  const updateCartDiscounts = (schoolDiscountId, schoolDiscountIds, discountCodes) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: discountCodes,
        attributes: {
          _schoolDiscountId: schoolDiscountId || null,
          _schoolDiscountIds: schoolDiscountIds || null,
          _discounts: discountCodes || null,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Uses Shopify's cart API to update the school name attribute in the cart.
  const updateCartSchoolName = (schoolName, garpCustomer, schoolDelivery) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          _schoolName: schoolName,
          _garpCustomer: garpCustomer,
          _schoolDelivery: schoolDelivery,
        },
      }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Close the school discount popup.
  const closeSchoolDiscountPopup = () => {
    if (schoolDiscountPopup) {
      body.classList.remove('overflow-hidden');
      schoolDiscountPopup.remove();
    }
  };

  if (schoolDiscountPopup) {
    // Close the school discount popup when the background is clicked or the close button is clicked.
    closeSchoolDiscountPopupButton?.addEventListener('click', closeSchoolDiscountPopup);

    // Close the popup if the background (not the inner content) is clicked.
    // Note that stopping event propagation when clicking inside the popup
    // breaks other click handlers, so this method has to be used instead.
    schoolDiscountPopup.addEventListener('click', (event) => {
      if (event.target === schoolDiscountPopup) {
        closeSchoolDiscountPopup();
      }
    });

    // When a school discount button is clicked, update the cart with the discount code and reload the page.
    schoolDiscountPopup.querySelectorAll('button[data-school-discount-id]').forEach((button) => {
      button.addEventListener('click', async () => {
        const schoolDiscountId = button.dataset.schoolDiscountId;
        const discountCodes = button.dataset.discountCodes;

        button.parentElement.querySelectorAll('button').forEach((button) => {
          button.classList.add('pointer-events-none');
        });

        button.querySelector('span').classList.add('hidden');
        button.querySelector('.fa-spinner-third').parentElement.classList.remove('hidden');

        await updateCartDiscounts(schoolDiscountId, !!schoolDiscountId ? schoolDiscountIds : null, discountCodes);

        window.location.href = hatDesignerUrl + '/hp=1';
      });
    });
  }

  // When a school is selected, show the corresponding discount information.
  schoolSelector?.addEventListener('schoolSelected', (event) => {
    const schoolName = event.detail?.name;
    const discountIds = event.detail?.discountIds;
    const garpCustomer = event.detail?.garpCustomer;
    const schoolDelivery = event.detail?.schoolDelivery;

    if (!schoolName) return;

    updateCartSchoolName(schoolName, garpCustomer, schoolDelivery);

    if (!discountIds) {
      closeSchoolDiscountPopup();
      return;
    }

    schoolDiscountIds = discountIds;

    schoolDiscountPopup.classList.add('bg-white');
    schoolDiscountPopup.classList.remove('sm:px-2xgutter', 'sm:pt-5xgutter', 'sm:pb-2xgutter', 'bg-white/75');
    schoolDiscountPopup.querySelector('div').classList.add('max-w-[calc(theme(spacing.gutter)*50)]');
    schoolDiscountPopup
      .querySelector('div')
      .classList.remove(
        'sm:max-w-7xgrid',
        'sm:h-auto',
        'sm:min-h-0',
        'sm:aspect-square',
        'sm:shadow-[0_4px_24px_16px_rgba(0,0,0,0.1)]'
      );

    schoolSelectorWrapper.remove();
    schoolDiscountsContainer.classList.remove('hidden');
    schoolDiscountsContainer.classList.add('flex');

    let count = 0;

    document.querySelectorAll('#school-discount-popup button[data-school-discount-id]').forEach((element) => {
      if (discountIds.split(',').includes(element.dataset.schoolDiscountId)) {
        element.classList.add('flex');
        element.classList.remove('hidden');
        count++;
      } else if (element.dataset.schoolDiscountId !== '') {
        element.remove();
      }
    });

    if (count > 1) {
      defaultButton?.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-popup"]) return;
  try {
    
  const body = document.querySelector('body');
  const sizeGuidePopup = document.getElementById('size-guide-popup');
  const closeSizeGuidePopupButton = document.getElementById('close-size-guide-popup-button');

  // Close the size guide popup.
  const closeSizeGuidePopup = () => {
    body.classList.remove('overflow-hidden');
    sizeGuidePopup.classList.remove('flex');
    sizeGuidePopup.classList.add('hidden');
  };

  // When the close button is clicked, close the popup.
  closeSizeGuidePopupButton.addEventListener('click', closeSizeGuidePopup);

  // When the background is clicked, close the popup.
  sizeGuidePopup.addEventListener('click', (event) => {
    if (event.target === sizeGuidePopup) {
      closeSizeGuidePopup();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
